// extracted by mini-css-extract-plugin
export default {"AdSlotMail__mail":"bgf_a bhf_wj bhf_a bhf_q bhf_k","AdSlotMail__mail--notLoaded":"bgf_b bhf_ey bhf_bj bhf_wy","show-ad-not-loaded":"bgf_c","AdSlotMail__cta":"bgf_e"};